module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('conteudo', {
    ref: "principal",
    attrs: {
      "id": "conteudo"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', [_vm._v(_vm._s(_vm.titulo))]), _c('p', [_vm._v(_vm._s(_vm.subtitulo))]), _c('p', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.data))]), _c('br')], 1), _c('div', {
    staticClass: "texto",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.imagem) ? _c('cover', {
    attrs: {
      "imagem": _vm.imagem,
      "legenda": _vm.imagemCaption
    }
  }) : _vm._e(), _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.corpo)
    }
  })], 1), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.autor) ? _c('p', {
    staticClass: "autor"
  }, [_vm._v("Autor: " + _vm._s(_vm.autor))]) : _vm._e(), (_vm.fonte) ? _c('p', {
    staticClass: "autor"
  }, [_vm._v("Fonte: " + _vm._s(_vm.fonte))]) : _vm._e(), (_vm.anexos.length) ? _c('ul', {
    staticClass: "anexos"
  }, _vm._l((_vm.anexos), function(anexo) {
    return _c('li', {
      key: anexo.id,
      staticClass: "item"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": anexo.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(anexo.nome))])])
  }), 0) : _vm._e(), (_vm.tags.length) ? _c('tags', {
    attrs: {
      "itens": _vm.tags
    }
  }) : _vm._e(), _c('back-and-share')], 1)]) : _c('conteudo', [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Carregando...")]), _c('div', {
    staticClass: "loading-container conteudo-loading",
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('div', {
    staticClass: "item header"
  }, [_c('div', {
    staticClass: "titulo animated"
  }), _c('div', {
    staticClass: "subtitulo animated"
  }), _c('div', {
    staticClass: "date animated"
  })]), _c('div', {
    staticClass: "item texto"
  }, [_c('div', {
    staticClass: "slot animated cover"
  }), _c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated three-quarter"
  }), _c('div', {
    staticClass: "paragraph animated middle"
  })]), _c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated three-quarter"
  }), _c('div', {
    staticClass: "paragraph animated middle"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9f7a3e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Noticia.vue
// module id = 522
// module chunks = 0